import React, { Fragment } from 'react';
import { Badge, Divider, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import useActionMenuStyles from './useActionMenuStyles';

export default function ActionMenuItems({
  actions = [],
  onSelect,
  firstDestructiveIndex = -1,
  highlightedActionId,
  badgeCount = 0,
}) {
  const styles = useActionMenuStyles();

  return actions.map((action, index) => (
    <Fragment key={action.id || action.label}>
      {action.destructive && index === firstDestructiveIndex && index > 0 ? (
        <Divider sx={styles.divider} />
      ) : null}
      <MenuItem
        disabled={action.disabled}
        disableRipple
        onClick={() => onSelect?.(action)}
        sx={{
          ...styles.item(action.destructive),
          minHeight: styles.itemHeight,
        }}
      >
        {action.icon ? (
          <ListItemIcon sx={styles.icon(action.destructive)}>
            {action.icon}
          </ListItemIcon>
        ) : null}
        <ListItemText
          primary={action.label}
          primaryTypographyProps={{ sx: styles.label(action.destructive) }}
          sx={{ my: 0 }}
        />
        {highlightedActionId === action.id && (
          <Badge
            badgeContent={badgeCount}
            color="error"
            max={99}
            invisible={!badgeCount}
            sx={{ ml: 1 }}
          >
            <NotificationsActiveOutlinedIcon
              sx={{
                fontSize: 17,
                color: '#f2b705',
                animation: 'chatNotificationPulse 900ms ease-in-out infinite',
                '@keyframes chatNotificationPulse': {
                  '0%, 100%': { opacity: 1, transform: 'scale(1)' },
                  '50%': { opacity: 0.35, transform: 'scale(1.18)' },
                },
              }}
            />
          </Badge>
        )}
      </MenuItem>
    </Fragment>
  ));
}
